import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { findValidI18nKey } from '../utils/languageUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorPageContent = ({
  errorCause,
  onClickLink
}) => {
  const titleKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.title`, 'pricingPage.pages.errorPage.default.title']);
  const paragraphKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.paragraph_jsx`, 'pricingPage.pages.errorPage.default.paragraph_jsx']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      height: 200,
      marginBlock: "1000"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h1",
      typography: "heading-300",
      marginBlockStart: "600",
      children: titleKey && /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleKey
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "1000",
      children: paragraphKey && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: paragraphKey,
        elements: {
          UILink: Link
        },
        options: {
          onClick: onClickLink
        }
      })
    })]
  });
};